import { NgModule } from '@angular/core';
import { provideConfig } from '../../../core/config/config-providers';
import { NOTIFICATION_API_ROUTES } from './api-routes';

@NgModule({
  providers: [provideConfig({ api: { endpoints: NOTIFICATION_API_ROUTES } })],
})
export class ConfigModule {}
